import RecepcionarTypes from './types'

export const clear = () => ({
    type: RecepcionarTypes.CLEAR
});

export const searchRequest = (value) => ({
    type: RecepcionarTypes.SEARCH_REQUEST,
    payload: value 
});

export const searchFailure = () => ({
    type: RecepcionarTypes.SEARCH_FAILURE
})

export const searchSuccess = (protocolos) => ({
    type: RecepcionarTypes.SEARCH_SUCCESS,
    payload:  protocolos
})
